// extracted by mini-css-extract-plugin
export default {"row":"cod_row__qKAqz","nowrap":"cod_nowrap__d67lQ","card":"cod_card__RBMYI"};